<template>
  <div
    class="icon-base"
    :class="{
      'icon-base_red': red,
      'icon-base_dark-red': darkRed,
      'icon-base_black': black,
      'icon-base_white': white,
      'icon-base_gray': gray,
      'icon-base_blue': blue,
      'icon-base_light-blue': lightBlue,
      'icon-base_green': green,
      'icon-base_orange': orange,
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    red: Boolean,
    darkRed: Boolean,
    black: Boolean,
    white: Boolean,
    gray: Boolean,
    blue: Boolean,
    green: Boolean,
    lightBlue: Boolean,
    orange: Boolean,
  },
};
</script>

<style lang="scss">
.icon-base {
  display: inline-block;
  height: auto;
  line-height: 0;
  @mixin colorizeSvg($color) {
    .svg-colorized-el {
      fill: $color;
      &__stroke {
        stroke: $color;
      }
    }
  }
  &.login-google {
    .svg-colorized-el {
      transition: $transition;
    }
  }
  &_black {
    @include colorizeSvg($black-color1);
  }
  &_red {
    @include colorizeSvg($red-color3);
  }
  &_dark-red {
    @include colorizeSvg($red-color9);
  }
  &_gray {
    @include colorizeSvg($grey-color2);
  }
  &_white {
    @include colorizeSvg($white-color2);
  }
  &_blue {
    @include colorizeSvg($blue-color3);
  }
  &_light-blue {
    @include colorizeSvg($blue-color4);
  }
  &_green {
    @include colorizeSvg($green-color1);
  }
  &_orange {
    @include colorizeSvg($orange-color2);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/uikit/IconBase.vue